import React from "react";
import { Typography } from "antd";
import { useTranslation } from "react-i18next";

const { Text } = Typography;

export default function TermsAndCond() {
    const { t } = useTranslation();

    const conditionsOfUseUrl = "https://optiwe.com/legal/terms/";
    const privacyPolicyUrl = "https://optiwe.com/legal/privacy/";

    return (
        <div style={{ paddingTop: "15px" }}>
            <Text type="secondary">
                {" "}
                {t("login.termsAndCondText")}
                <a href={conditionsOfUseUrl}> {t("login.terms")} </a>
                {t("and")}
                <a href={privacyPolicyUrl}> {t("login.privacy")}</a>
            </Text>
        </div>
    );
}
